// extracted by mini-css-extract-plugin
export default {"terminal":"Terminals_terminal__TNsFJ","background":"Terminals_background__Doc0u","hasTerminals":"Terminals_hasTerminals__qD5XK"};